import React, { FC } from 'react';
import { useTranslate } from '@/translations';
import { AuthorizationStatus } from '@/types';
import { AuthorizationNotesModal } from './AuthorizationNotesModal';

export type BatchActionsPopupProps = {
  visible: boolean;
  authorizationStatus: AuthorizationStatus;
  loading: boolean;
  onSubmit: (status: AuthorizationStatus, comment: string) => Promise<void>;
  onClose: () => void;
};

export const BatchActionsPopup: FC<BatchActionsPopupProps> = ({
  visible,
  authorizationStatus,
  loading,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslate();

  const title = t(
    authorizationStatus === AuthorizationStatus.Approved
      ? 'approveStatusQuestion'
      : 'rejectStatusQuestion',
  );

  return (
    <AuthorizationNotesModal
      visible={visible}
      title={title}
      loading={loading}
      onClose={onClose}
      isConfirmDisabled={(comment) =>
        (authorizationStatus === AuthorizationStatus.Rejected &&
          (!comment || !comment.length)) ||
        false
      }
      onConfirm={async (comment) => {
        await onSubmit(authorizationStatus, comment || '');
      }}
    />
  );
};
